import { createFileRoute, redirect } from "@tanstack/react-router";

/** /signup (exact) — redirect to step 1. */
export const Route = createFileRoute("/$locale/{-$schoolyear}/signup/")({
  loader: ({ params }) => {
    throw redirect({
      to: "/$locale/{-$schoolyear}/signup/step/1",
      params: { locale: params.locale, schoolyear: params.schoolyear },
    });
  },
  component: () => null,
});
